/*
 * @Author: 1544807500@qq.com
 * @Date: 2025-06-13 10:28
 * @LastEditors: 1544807500@qq.com
 * @LastEditTime: 2025-06-13 14:40
 * @FilePath: \glyun_web_Vue3\src\router\otaUpgrade.js
 * @Description: ota升级路由
 */
export default [
  {
    path: '/otaUpgrade',
    redirect: '/otaUpgrade/dataBoard',
    name: 'otaUpgrade',
    component: () => import('../views/nav/index.vue'),
    children: [
      {//数据看板
        path: 'dataBoard',
        name: 'otaUpgradeDataBoard',
        component: () => import('../views/otaUpgrade/dataBoard/index.vue'),
        meta: {
          title: "v2_device_abnormal_warning_data_board",
          routeAuthCode: 'A1103',
        }
      },
      {//固件管理
        path: 'firmwareManagement',
        redirect: '/otaUpgrade/firmwareManagement/inverter',
        name: 'otaUpgradeFirmwareManagement',
        children: [
          {//逆变器
            path: 'inverter',
            name: 'otaUpgradeFirmwareManagementInverter',
            component: () => import('../views/otaUpgrade/firmwareManagement/inverter/index.vue'),
            meta: {
              title: "v2_device_inverter",
              routeAuthCode: 'A1100',
            }
          },
          {//采集器
            path: 'collector',
            name: 'otaUpgradeFirmwareManagementCollector',
            component: () => import('../views/otaUpgrade/firmwareManagement/collector/index.vue'),
            meta: {
              title: "v2_device_datalogger",
              routeAuthCode: 'A1100',
            },
          },
          {//EPM
            path: 'epm',
            name: 'otaUpgradeFirmwareManagementEpm',
            component: () => import('../views/otaUpgrade/firmwareManagement/epm/index.vue'),
            meta: {
              title: "EPM",
              routeAuthCode: 'A1100',
            }
          },
          {//聚合升级
            path: 'bigPackage',
            name: 'otaUpgradeFirmwareManagementBigPackage',
            component: () => import('../views/otaUpgrade/firmwareManagement/bigPackage/index.vue'),
            meta: {
              title: "v2_ota_aggregated_upgrade",
              routeAuthCode: 'A1100',
            }
          },
          {// 充电桩
            path: 'charger',
            name: 'otaUpgradeFirmwareManagementCharger',
            component: () => import('../views/otaUpgrade/firmwareManagement/charger/index.vue'),
            meta: {
              title: "v2_charger_charger",
              routeAuthCode: 'A1100',
            }
          },
          {//电池
            path: 'battery',
            name: 'otaUpgradeFirmwareManagementBattery',
            component: () => import('../views/otaUpgrade/firmwareManagement/battery/index.vue'),
            meta: {
              title: "v2_plant_details_battery",
              routeAuthCode: 'A1100',
            }
          },
          {//hub
            path: 'hub',
            name: 'otaUpgradeFirmwareManagementHub',
            component: () => import('../views/otaUpgrade/firmwareManagement/hub/index.vue'),
            meta: {
              title: "v2_grid_cabinet1",
              routeAuthCode: 'A1100',
            }
          },
          {//rsd
            path: 'rsd',
            name: 'otaUpgradeFirmwareManagementRsd',
            component: () => import('../views/otaUpgrade/firmwareManagement/rsd/index.vue'),
            meta: {
              title: "v2_rapid_shutdown",
              routeAuthCode: 'A1100',
            }
          },
          {//ems
            path: 'ems',
            name: 'otaUpgradeFirmwareManagementEms',
            component: () => import('../views/otaUpgrade/firmwareManagement/ems/index.vue'),
            meta: {
              title: "EMS",
              routeAuthCode: 'A1100',
            }
          },
        ],
      },
      {//任务管理
        path: 'taskManagement',
        redirect: '/otaUpgrade/taskManagement/inverter',
        name: 'otaUpgradeTaskManagement',
        children: [
          {//逆变器
            path: 'inverter',
            name: 'otaUpgradeTaskManagementInverter',
            component: () => import('../views/otaUpgrade/taskManagement/inverter/index.vue'),
            meta: {
              title: "v2_device_inverter",
              routeAuthCode: 'A1101',
            }
          },
          {//采集器
            path: 'collector',
            name: 'otaUpgradeTaskManagementCollector',
            component: () => import('../views/otaUpgrade/taskManagement/collector/index.vue'),
            meta: {
              title: "v2_device_datalogger",
              routeAuthCode: 'A1101',
            }
          },
          {//EPM
            path: 'epm',
            name: 'otaUpgradeTaskManagementEpm',
            component: () => import('../views/otaUpgrade/taskManagement/epm/index.vue'),
            meta: {
              title: "EPM",
              routeAuthCode: 'A1101',
            }
          },
          {//聚合升级
            path: 'bigPackage',
            name: 'otaUpgradeTaskManagementBigPackage',
            component: () => import('../views/otaUpgrade/taskManagement/bigPackage/index.vue'),
            meta: {
              title: "v2_ota_aggregated_upgrade",
              routeAuthCode: 'A1101',
            }
          },
          {//充电桩
            path: 'charger',
            name: 'otaUpgradeTaskManagementCharger',
            component: () => import('../views/otaUpgrade/taskManagement/charger/index.vue'),
            meta: {
              title: "v2_charger_charger",
              routeAuthCode: 'A1101',
            }
          },
          {//battery
            path: 'battery',
            name: 'otaUpgradeTaskManagementBattery',
            component: () => import('../views/otaUpgrade/taskManagement/battery/index.vue'),
            meta: {
              title: "v2_plant_details_battery",
              routeAuthCode: 'A1101',
            }
          },
          {//hub
            path: 'hub',
            name: 'otaUpgradeTaskManagementHub',
            component: () => import('../views/otaUpgrade/taskManagement/hub/index.vue'),
            meta: {
              title: "v2_grid_cabinet1",
              routeAuthCode: 'A1101',
            }
          },
          {//rsd
            path: 'rsd',
            name: 'otaUpgradeTaskManagementRsd',
            component: () => import('../views/otaUpgrade/taskManagement/rsd/index.vue'),
            meta: {
              title: "v2_rapid_shutdown",
              routeAuthCode: 'A1101',
            }
          },
          {//ems
            path: 'ems',
            name: 'otaUpgradeTaskManagementEms',
            component: () => import('../views/otaUpgrade/taskManagement/ems/index.vue'),
            meta: {
              title: "EMS",
              routeAuthCode: 'A1101',
            }
          },
        ],
      },
      {//近端固件启停管理
        path: 'firmwareStartStopManagement',
        name: 'otaUpgradeFirmwareStartStopManagement',
        component: () => import('../views/otaUpgrade/firmwareStartStopManagement/index.vue'),
        meta: {
          title: 'v2_ota_local_firmware_start_stop_management'
        }
      },
      {//压力升级
        path: 'loopUpgrade',
        name: 'otaUpgradeLoopUpgrade',
        component: () => import('../views/otaUpgrade/loopUpgrade/index.vue'),
        meta: {
          title: 'v2_equipment_upgrade_pressure_upgrade',
          routeAuthCode: 'A1106'
        }
      },
      {
        // 固件兼容矩阵：配置和维护不同固件版本之间的兼容关系。
        path: 'compatibilityRule',
        name: 'otaUpgradeCompatibilityRule',
        component: () => import('../views/otaUpgrade/compatibilityRule/index.vue'),
        meta: {
          title: 'v2_compatibility_matrix',
          routeAuthCode: 'A1107'
        }
      },
      {//升级记录
        path: 'upgradeRecord',
        redirect: '/otaUpgrade/upgradeRecord/inverter',
        name: 'otaUpgradeUpgradeRecord',
        children: [
          {//逆变器
            path: 'inverter',
            name: 'otaUpgradeUpgradeRecordInverter',
            component: () => import('../views/otaUpgrade/upgradeRecord/inverter/index.vue'),
            meta: {
              title: "v2_export_record_device_upgrade_record",
              routeAuthCode: 'A1102',
            }
          },
          {//采集器
            path: 'collector',
            name: 'otaUpgradeUpgradeRecordCollector',
            component: () => import('../views/otaUpgrade/upgradeRecord/collector/index.vue'),
            meta: {
              title: "v2_export_record_device_upgrade_record",
              routeAuthCode: 'A1102',
            }
          },
          {//EPM
            path: 'epm',
            name: 'otaUpgradeUpgradeRecordEpm',
            component: () => import('../views/otaUpgrade/upgradeRecord/epm/index.vue'),
            meta: {
              title: "v2_export_record_device_upgrade_record",
              routeAuthCode: 'A1102',
            }
          },
          {//充电桩
            path: 'charger',
            name: 'otaUpgradeUpgradeRecordCharger',
            component: () => import('../views/otaUpgrade/upgradeRecord/charger/index.vue'),
            meta: {
              title: "v2_ev_charger_upgrade_history",
              routeAuthCode: 'A1102',
            }
          },
          {//聚合升级
            path: 'bigPackage',
            name: 'otaUpgradeUpgradeRecordBigPackage',
            component: () => import('../views/otaUpgrade/upgradeRecord/bigPackage/index.vue'),
            meta: {
              title: "v2_ota_aggregated_upgrade",
              routeAuthCode: 'A1102',
            }
          },
          {//电池
            path: 'battery',
            name: 'otaUpgradeUpgradeRecordBattery',
            component: () => import('../views/otaUpgrade/upgradeRecord/battery/index.vue'),
            meta: {
              title: "v2_plant_details_battery",
              routeAuthCode: 'A1102',
            }
          },
          {//hub
            path: 'hub',
            name: 'otaUpgradeUpgradeRecordHub',
            component: () => import('../views/otaUpgrade/upgradeRecord/battery/index.vue'),
            meta: {
              title: "v2_grid_cabinet1",
              routeAuthCode: 'A1102',
            }
          },
          {//rsd
            path: 'rsd',
            name: 'otaUpgradeUpgradeRecordRsd',
            component: () => import('../views/otaUpgrade/upgradeRecord/rsd/index.vue'),
            meta: {
              title: "v2_rapid_shutdown",
              routeAuthCode: 'A1102',
            }
          },
          {//ems
            path: 'ems',
            name: 'otaUpgradeUpgradeRecordEms',
            component: () => import('../views/otaUpgrade/upgradeRecord/ems/index.vue'),
            meta: {
              title: "EMS",
              routeAuthCode: 'A1102',
            }
          },
        ],
      },
      {//用户升级申请
        path: 'userUpgradeApplication',
        redirect: '/otaUpgrade/userUpgradeApplication/inverter',
        name: 'otaUpgradeUserUpgradeApplication',
        children: [
          {//逆变器
            path: 'inverter',
            name: 'otaUpgradeUserUpgradeApplicationInverter',
            component: () => import('../views/otaUpgrade/userUpgradeApplication/inverter/index.vue'),
            meta: {
              title: "v2_task_management_ota_upgrade",
              routeAuthCode: 'A1104',
            }
          },
          {//采集器
            path: 'collector',
            name: 'otaUpgradeUserUpgradeApplicationCollector',
            component: () => import('../views/otaUpgrade/userUpgradeApplication/collector/index.vue'),
            meta: {
              title: "v2_task_management_ota_upgrade",
              routeAuthCode: 'A1104',
            }
          },
        ],
      },
    ],
  },
]
